import Typed from 'typed.js'
import {TimelineMax} from 'gsap';
import {headerTextTimeline} from './headerText';




    let typedTextTineline = new TimelineMax({
        paused: true
    });


    typedTextTineline.fromTo('#typedText',1,
    {
        fontSize:'5em',
        top:"25rem"
    },
    {
        fontSize:'4em',
        top:'0'
    })


    typedTextTineline.eventCallback("onComplete", function(){
         headerTextTimeline.play()
    }, ["param1","param2"]);




var typed = new Typed('#typedText', {
    stringsElement: '#typed-data',
    loop: false,
    typeSpeed: 50,
    onComplete:function(){
        console.log('DONE ')
        typedTextTineline.play()
        document.getElementsByClassName('typed-cursor')[0].style.visibility = 'hidden';
        

    }
  });



 